import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from 'components/BaseComponent';

import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleActionActivator } from '../../components/SimulatedVehicleTask';
import { KanbanColumnFilter } from '../../components/ColumnFilter';
import { selectWorks } from '../../../Api/selectors';
import { forceKanbanCacheRefresh } from '../../actions';
import { REQUEST_KANBAN_BOARD_COLUMN_CELLS } from '../../constants';
import { selectKanbanBoardColumnDirty } from '../../selectors';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Header = styled.div`
  margin: -6px -6px 6px -6px;
  padding: 12px;
  font-weight: bold;
  background-color: #f0f1f9;
  border: 1px solid #e0e1eb;
  border-bottom: none;
  color: #808185;
  font-size: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 5px;
  .buttons {
    width: 130px;
    .button {
      margin: 0 2px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardColumnHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return (
      <Header>
        {this.props.work || this.props.isDirty ? <Loader small /> : null}
        {this.props.label}
        <HBox right className="buttons gap-2">
          <KanbanColumnFilter
            action={this.props.action}
            actionClass={this.props.actionClass}
            board_id={this.props.board_id}
            column={this.props.column}
          />
          <ButtonComponent
            size={'btn-sm'}
            style={'ButtonSoftPrimary'}
            onClick={this.props.forceCacheRefresh}
            disabled={this.props.work || this.props.isDirty}
          >
            <EditSquare />
          </ButtonComponent>
          {!this.props.isCompanyAction && (
            <VehicleActionActivator
              action={this.props.action}
              actionClass={this.props.actionClass}
              board_id={this.props.board_id}
              column={this.props.column}
              loggedUserId={this.props.loggedUserId}
              payload={this.props.payload}
              onChange={this.props.onChange}
            />
          )}
        </HBox>
      </Header>
    );
  }
}

KanbanBoardColumnHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_COLUMN_CELLS}${ownProps.board_id}_${ownProps.column.id}`]),
    isDirty: selectKanbanBoardColumnDirty(ownProps.board_id, ownProps.column.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    forceCacheRefresh() {
      dispatch(forceKanbanCacheRefresh(ownProps.board_id, ownProps.column.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardColumnHeader = compose(withConnect, withRouter)(KanbanBoardColumnHeaderComp);
